import { api } from "./api";

export const customReportValidateApi = (params) => {
  return api.post(`/custom-report/validate`, JSON.stringify(params));
};

export const customReportExecuteApi = (params) => {
  return api.post(`/custom-report/execute`, JSON.stringify(params));
};

export const customReportSaveApi = (params) => {
  return api.post(`/custom-report/save`, JSON.stringify(params));
};

export const customReportListApi = () => {
  return api.get(`/custom-report/list`);
};

export const customReportGetApi = (reportId) => {
  return api.get(`/custom-report/get/${reportId}`);
};

export const customReportUpdateApi = (params) => {
  return api.post(`/custom-report/update`, JSON.stringify(params));
};

export const customReportDeleteApi = (params) => {
  return api.post(`/custom-report/delete`, JSON.stringify(params));
};

export const customReportSchemaApi = () => {
  return api.get(`/custom-report/schema`);
};

export const customReportExportExcelApi = (params) => {
  return api.post(`/custom-report/export/excel`, JSON.stringify(params), {
    responseType: "blob",
  });
};

export const customReportExportPdfApi = (params) => {
  return api.post(`/custom-report/export/pdf`, JSON.stringify(params), {
    responseType: "blob",
  });
};
